// extracted by mini-css-extract-plugin
export var dataCell = "_n1-2";
export var dataRow = "_n1-0";
export var headerRow = "_n1-1";